"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protocolVersion = exports.version = void 0;
exports.version = '0.10.1';
exports.protocolVersion = 2;
//# sourceMappingURL=version.js.map